import { usePortalContext } from "./PortalProvider";

interface Props {
  name: string;
  children?: React.ReactNode;
}

export function PortalHost({ name, children }: Props) {
  const { getPortalHost } = usePortalContext();

  const hostContent = getPortalHost(name);
  if (hostContent) {
    return <>{hostContent}</>;
  }

  return children ?? null;
}
